<template>
  <div v-if="showTopBorder" class="h-px w-full bg-grey-35"></div>
  <div class="flex justify-between text-base font-semibold text-indigo-500">
    <div class="flex cursor-pointer gap-1">
      <slot class="left">
        <button class="flex gap-x-1" @click="leftCallback">
          <div v-if="leftText" class="flex size-6 min-h-6 min-w-6 items-center justify-center">
            <zoom-in class="*:fill-indigo-500" />
          </div>

          <p class="select-none">{{ leftText }}</p>
        </button>
      </slot>
    </div>

    <button class="cursor-pointer select-none" @click="rightCallback">{{ rightText }}</button>
  </div>
</template>

<script setup lang="ts">
import ZoomIn from '@/common/assets/icons/zoom-in.svg';

withDefaults(
  defineProps<{
    showTopBorder?: boolean;

    leftText?: string;

    rightText?: string;

    leftCallback?: () => void;

    rightCallback?: () => void;
  }>(),
  {
    showTopBorder: true,

    leftText: 'Zoom map',
    rightText: 'See full warning',

    leftCallback: undefined,
    rightCallback: undefined,
  }
);
</script>
